export default {
  UPLOAD_SENDS_BARCODE_LOADING: '@UPLOAD_SENDS_BARCODE_LOADING',
  UPLOAD_SENDS_BARCODE_ERROR: '@UPLOAD_SENDS_BARCODE_ERROR',
  UPLOAD_SENDS_BARCODE_SUCCESS: '@UPLOAD_SENDS_BARCODE_SUCCESS',
  UPLOAD_SENDS_BARCODE_CLEAR: '@UPLOAD_SENDS_BARCODE_CLEAR',

  SENDS_EMAIL_RECEIPT_LOADING: '@SENDS_EMAIL_RECEIPT_LOADING',
  SENDS_EMAIL_RECEIPT_SUCCESS: '@SENDS_EMAIL_RECEIPT_SUCCESS',
  SENDS_EMAIL_RECEIPT_ERROR: '@SENDS_EMAIL_RECEIPT_ERROR',

  ACCOUNT_DETAILS_LOADING: '@ACCOUNT_DETAILS_LOADING',
  ACCOUNT_DETAILS_SUCCESS: '@ACCOUNT_DETAILS_SUCCESS',
  ACCOUNT_DETAILS_ERROR: '@ACCOUNT_DETAILS_ERROR',
  ACCOUNT_DETAILS_UPDATE_PAYMENTS_ERROR_RESET: '@ACCOUNT_DETAILS_UPDATE_PAYMENTS_ERROR_RESET',
  ACCOUNT_DETAILS_SELECT_SHIPPING_ADDRESS: '@ACCOUNT_DETAILS_SELECT_SHIPPING_ADDRESS',
  ACCOUNT_DETAILS_UPDATE_PAYMENTS_ERROR: '@ACCOUNT_DETAILS_UPDATE_PAYMENTS_ERROR',
  ACCOUNT_DETAILS_UPDATE_PAYMENTS_SUCCESS: '@ACCOUNT_DETAILS_UPDATE_PAYMENTS_SUCCESS',
  ACCOUNT_DETAILS_UPDATE_PAYMENTS_LOADING: '@ACCOUNT_DETAILS_UPDATE_PAYMENTS_LOADING',
  ACCOUNT_DETAILS_SELECT_PAYMENTS: '@ACCOUNT_DETAILS_SELECT_PAYMENTS',
  ACCOUNT_DETAILS_ADD_GIFT_CARD_ERROR: '@ACCOUNT_DETAILS_ADD_GIFT_CARD_ERROR',
  ACCOUNT_DETAILS_ADD_GIFT_CARD: '@ACCOUNT_DETAILS_ADD_GIFT_CARD',
  ACCOUNT_DETAILS_UPDATE_GIFT_CARDS: '@ACCOUNT_DETAILS_UPDATE_GIFT_CARDS',
  ACCOUNT_DETAILS_SELECT_GIFT_CARDS: '@ACCOUNT_DETAILS_SELECT_GIFT_CARDS',
  ACCOUNT_DETAILS_UPDATE_GIFT_CARDS_AFTER_FAILED_PAYMENT: '@ACCOUNT_DETAILS_UPDATE_GIFT_CARDS_AFTER_FAILED_PAYMENT',
  ACCOUNT_DETAILS_ADD_LOYALITY_GIFT_CARDS: '@ACCOUNT_DETAILS_ADD_LOYALITY_GIFT_CARDS',
  ACCOUNT_DETAILS_CHECK_LOYALTY_CARD_BALANCE: '@ACCOUNT_DETAILS_CHECK_LOYALTY_CARD_BALANCE',
  ACCOUNT_DETAILS_SET_SUBMITTED_AMOUNTS: '@ACCOUNT_DETAILS_SET_SUBMITTED_AMOUNTS',
  ACCOUNT_DETAILS_RESET: '@ACCOUNT_DETAILS_RESET',

  SHIPMENT_OPTIONS_LOADING: '@SHIPMENT_OPTIONS_LOADING',
  SHIPMENT_OPTIONS_SUCCESS: '@SHIPMENT_OPTIONS_SUCCESS',
  SHIPMENT_OPTIONS_ERROR: '@SHIPMENT_OPTIONS_ERROR',
  SHIPMENT_PROMO_ERROR: '@SHIPMENT_PROMO_ERROR',
  SHIPMENT_OPTIONS_ERROR_RESET: '@SHIPMENT_OPTIONS_ERROR_RESET',
  SHIPMENT_PROMO_ERROR_RESET: '@SHIPMENT_PROMO_ERROR_RESET',
  SHIPMENT_SET_TRANSACTION_TYPE: '@SHIPMENT_SET_TRANSACTION_TYPE',
  SHIPMENT_SET_SHIPMENT_METHOD_ID: '@SHIPMENT_SET_SHIPMENT_METHOD_ID',
  SHIPMENT_RESET: '@SHIPMENT_RESET',

  CHECKOUT_SUBMIT_ORDER_SUBMITTING: '@CHECKOUT_SUBMIT_ORDER_SUBMITTING',
  CHECKOUT_SUBMIT_ORDER_ERROR: '@CHECKOUT_SUBMIT_ORDER_ERROR',
  CHECKOUT_PAYMENT_ERROR: '@CHECKOUT_PAYMENT_ERROR',
  CHECKOUT_CACHE_ORDER_DATA: '@CHECKOUT_CACHE_ORDER_DATA',
  CHECKOUT_PAYMENT_CARD_VALIDATION_ERROR: '@CHECKOUT_PAYMENT_CARD_VALIDATION_ERROR',
  CHECKOUT_SUBMIT_ORDER_SUCCESS: '@CHECKOUT_SUBMIT_ORDER_SUCCESS',
  CHECKOUT_SET_ORDER_META_DATA: '@CHECKOUT_SET_ORDER_META_DATA',
  CHECKOUT_VOID_ORDER_SUBMITTING: '@CHECKOUT_VOID_ORDER_SUBMITTING',
  CHECKOUT_VOID_ORDER_COMPLETE: '@CHECKOUT_VOID_ORDER_COMPLETE',
  CHECKOUT_RESET: '@CHECKOUT_RESET',
  CHECKOUT_OVERRIDE_MODAL_NEED: '@CHECKOUT_OVERRIDE_MODAL_NEED',
  CHECKOUT_RESET_OVERRIDE_MODAL_NEED: '@CHECKOUT_OVERRIDE_MODAL_NEED',

  SELECT_PAYMENT_CONFIRM: '@SELECT_PAYMENT_CONFIRM',
  SELECT_PAYMENT_CHECK_CREDIT_CARDS: '@SELECT_PAYMENT_CHECK_CREDIT_CARDS',
  SELECT_PAYMENT_CHECK_GIFT_CARDS: '@SELECT_PAYMENT_CHECK_GIFT_CARDS',
  SELECT_PAYMENT_SET_AMOUNTS_MAP: '@SELECT_PAYMENT_SET_AMOUNTS_MAP',
  SELECT_PAYMENT_RESET_SELECTION: '@SELECT_PAYMENT_RESET_SELECTION',
  SELECT_PAYMENT_SWITCH_PED: '@SELECT_PAYMENT_SWITCH_PED',
  SELECT_PAYMENT_SELECT_SLED: '@SELECT_PAYMENT_SELECT_SLED',
  SELECT_PAYMENT_RESET_STATE: '@SELECT_PAYMENT_RESET_STATE',
};
